const shouldAttemptCriteoRequest = ({ categoryId, searchTerm }) =>
  !!categoryId || !!searchTerm;

export default shouldAttemptCriteoRequest;
